import { render, staticRenderFns } from "./Invest.vue?vue&type=template&id=faa1f4ce&scoped=true&"
import script from "./Invest.vue?vue&type=script&lang=js&"
export * from "./Invest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa1f4ce",
  null
  
)

export default component.exports